import { initDisplayErrorMessageInterceptor } from './display-error-message';
import { initAuthInterceptor } from './handle-unauthorized';
export var initHttpInterceptors = function () {
    initAuthInterceptor();
    initDisplayErrorMessageInterceptor();
};
